export default __webpack_public_path__ + "static/media/database_1.20fc3bc5.png";